import Vue from 'vue';
import flatpickr from "flatpickr";
import flatPickrComponent from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import l10n from 'flatpickr/dist/l10n/zh';

flatpickr.localize(l10n.zh);

// 默认配置
flatpickr.setDefaults({
    locale: l10n.zh,
    enableTime: true,
})


Vue.use(flatPickrComponent);



export default flatPickrComponent;
